import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=12a9ba1e&scoped=true"
import script from "./MainHome.vue?vue&type=script&lang=js"
export * from "./MainHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9ba1e",
  null
  
)

export default component.exports